import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, ChevronDown, ChevronUp, Truck, CheckCircle, Clock, ArrowRight } from 'lucide-react';
import Header from './components/Header8';
import Footer from './components/Footer8';

const Orders8 = () => {
    const navigate = useNavigate();
    const [expandedOrder, setExpandedOrder] = useState(null);

    const orders = [
        {
            id: 'MHK-2026001', date: '15 Mar 2026', status: 'delivered', total: 7499,
            items: [{ name: 'Rose Silk Anarkali', quantity: 1, size: 'M', price: 7499, image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=800' }],
            shippingAddress: '12 C-Scheme, Jaipur, Rajasthan 302001', trackingNumber: 'MHK-TRK-78291', deliveredDate: '18 Mar 2026',
        },
        {
            id: 'MHK-2026002', date: '10 Mar 2026', status: 'in_transit', total: 17998,
            items: [
                { name: 'Designer Banarasi Saree', quantity: 1, size: 'Free Size', price: 12999, image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=800' },
                { name: 'Festive Palazzo Suit', quantity: 1, size: 'S', price: 4999, image: 'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=800' },
            ],
            shippingAddress: '45 Bani Park, Jaipur, Rajasthan 302016', trackingNumber: 'MHK-TRK-78405', expectedDelivery: '22 Mar 2026',
        },
        {
            id: 'MHK-2026003', date: '5 Mar 2026', status: 'processing', total: 24999,
            items: [{ name: 'Bridal Lehenga Set', quantity: 1, size: 'M', price: 24999, image: 'https://images.pexels.com/photos/3014853/pexels-photo-3014853.jpeg?auto=compress&cs=tinysrgb&w=800' }],
            shippingAddress: '78 Vaishali Nagar, Jaipur, Rajasthan 302021', trackingNumber: 'MHK-TRK-78512', expectedDelivery: '28 Mar 2026',
        },
    ];

    const statusConfig = {
        delivered: { label: 'Delivered', color: '#16a34a', bg: '#f0fdf4', icon: CheckCircle },
        in_transit: { label: 'In Transit', color: '#BE185D', bg: '#FDF2F8', icon: Truck },
        processing: { label: 'Processing', color: '#d97706', bg: '#fffbeb', icon: Clock },
    };

    return (
        <>
            <style>{`@import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&family=DM+Sans:wght@300;400;500;700&display=swap');`}</style>
            <div style={{ fontFamily: "'DM Sans', sans-serif" }} className="min-h-screen bg-white">
                <Header />
                <main className="pt-24 pb-16 px-4 lg:px-8">
                    <div className="max-w-[1000px] mx-auto">
                        <div className="mb-10">
                            <p className="text-sm tracking-[0.3em] uppercase mb-2 font-medium" style={{ color: '#BE185D' }}>Your Orders</p>
                            <h1 style={{ fontFamily: "'Libre Baskerville', serif" }} className="text-3xl lg:text-4xl font-bold">Order History</h1>
                        </div>

                        {orders.length === 0 ? (
                            <div className="text-center py-24">
                                <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: '#FDF2F8' }}>
                                    <Package size={32} style={{ color: '#F9A8D4' }} />
                                </div>
                                <h2 style={{ fontFamily: "'Libre Baskerville', serif" }} className="text-2xl font-bold mb-3">No orders yet</h2>
                                <p className="text-sm mb-6" style={{ color: '#6B7280' }}>Start shopping to fill your garden with beautiful pieces.</p>
                                <button onClick={() => navigate('/template8/shop')} className="inline-flex items-center gap-2 px-8 py-3 rounded-lg text-sm font-semibold uppercase tracking-wider" style={{ backgroundColor: '#BE185D', color: '#FFFFFF' }}>
                                    Start Shopping <ArrowRight size={16} />
                                </button>
                            </div>
                        ) : (
                            <div className="space-y-4">
                                {orders.map((order) => {
                                    const status = statusConfig[order.status];
                                    const StatusIcon = status.icon;
                                    const isExpanded = expandedOrder === order.id;
                                    return (
                                        <div key={order.id} className="rounded-xl overflow-hidden" style={{ border: '1px solid #F9A8D4' }}>
                                            <button onClick={() => setExpandedOrder(isExpanded ? null : order.id)} className="w-full flex items-center justify-between p-4 lg:p-6" style={{ backgroundColor: '#FDF2F8' }}>
                                                <div className="flex items-center gap-4">
                                                    <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: status.bg }}>
                                                        <StatusIcon size={18} style={{ color: status.color }} />
                                                    </div>
                                                    <div className="text-left">
                                                        <p className="text-sm font-semibold">{order.id}</p>
                                                        <p className="text-xs" style={{ color: '#6B7280' }}>{order.date}</p>
                                                    </div>
                                                </div>
                                                <div className="flex items-center gap-4">
                                                    <span className="px-3 py-1 rounded-full text-xs font-semibold" style={{ backgroundColor: status.bg, color: status.color }}>{status.label}</span>
                                                    <span className="text-sm font-bold hidden sm:block" style={{ color: '#BE185D' }}>{`\u20B9${order.total.toLocaleString('en-IN')}`}</span>
                                                    {isExpanded ? <ChevronUp size={18} style={{ color: '#6B7280' }} /> : <ChevronDown size={18} style={{ color: '#6B7280' }} />}
                                                </div>
                                            </button>
                                            {isExpanded && (
                                                <div className="p-4 lg:p-6 space-y-4" style={{ borderTop: '1px solid #F9A8D4' }}>
                                                    {order.items.map((item, i) => (
                                                        <div key={i} className="flex gap-4">
                                                            <img src={item.image} alt={item.name} className="w-16 h-20 rounded-lg object-cover" />
                                                            <div>
                                                                <p className="text-sm font-semibold">{item.name}</p>
                                                                <p className="text-xs" style={{ color: '#6B7280' }}>Size: {item.size} | Qty: {item.quantity}</p>
                                                                <p className="text-sm font-bold mt-1" style={{ color: '#BE185D' }}>{`\u20B9${item.price.toLocaleString('en-IN')}`}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4" style={{ borderTop: '1px solid #F9A8D4' }}>
                                                        <div>
                                                            <p className="text-xs font-semibold mb-1" style={{ color: '#BE185D' }}>Shipping Address</p>
                                                            <p className="text-sm" style={{ color: '#6B7280' }}>{order.shippingAddress}</p>
                                                        </div>
                                                        <div>
                                                            <p className="text-xs font-semibold mb-1" style={{ color: '#BE185D' }}>Tracking</p>
                                                            <p className="text-sm" style={{ color: '#6B7280' }}>{order.trackingNumber}</p>
                                                            {order.deliveredDate && <p className="text-xs mt-1" style={{ color: '#16a34a' }}>Delivered on {order.deliveredDate}</p>}
                                                            {order.expectedDelivery && <p className="text-xs mt-1" style={{ color: '#d97706' }}>Expected by {order.expectedDelivery}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </main>
                <Footer />
            </div>
        </>
    );
};

export default Orders8;
